import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';
import { getVisitsSchema } from '../visits/getVisits';
export const getVisitLoginSchema = baseObjectSchema.extend({
  visitId: z.string(),
  visit: getVisitsSchema.optional(),
  longitude: z.string(),
  latitude: z.string(),
  loginDateStamp: z.string(),
  logoutDateStamp: z.string().nullable(),
  sequence: z.number().optional(),
});
export type GetVisitLoginsResponse = z.infer<typeof getVisitLoginSchema>;

export const getVisitLoginsSchema = z.array(getVisitLoginSchema);
